"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationInitRequest = void 0;
var ReservationInitRequest = /** @class */ (function () {
    function ReservationInitRequest() {
    }
    return ReservationInitRequest;
}());
exports.ReservationInitRequest = ReservationInitRequest;
;
//# sourceMappingURL=reservationInit.request.js.map